import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="relative w-full py-24 sm:py-32 overflow-hidden" data-id="element-148">
      {/* Decorative orb */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-purple-electric/[0.04] rounded-full blur-[120px] pointer-events-none" data-id="element-149" />

      <div className="relative max-w-3xl mx-auto px-6 text-center" data-id="element-150">
        {/* Accent line */}
        <motion.div initial={{
        scaleX: 0
      }} whileInView={{
        scaleX: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        ease: [0.22, 1, 0.36, 1]
      }} className="w-16 h-px bg-gradient-to-r from-transparent via-purple-electric to-transparent mx-auto mb-12" data-id="element-151" />

        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.9,
        ease: [0.22, 1, 0.36, 1]
      }} className="font-serif text-3xl sm:text-4xl md:text-5xl font-bold text-white leading-tight mb-8" data-id="element-152">
          ¿Sientes que la realidad tiene una capa más profunda{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-electric to-astral" data-id="element-153">
            pero no sabes cómo verla?
          </span>
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: [0.22, 1, 0.36, 1]
      }} className="space-y-5" data-id="element-154">
          <p className="font-sans text-lg text-white/40 leading-relaxed" data-id="element-155">
            Has buscado en la religión, pero encontraste dogmas. Has buscado en
            la ciencia, pero encontraste límites. Algo dentro de ti sabe que
            existe un puente entre ambos mundos — un lenguaje que conecta lo
            sagrado con lo medible.
          </p>
          <p className="font-sans text-lg text-white/40 leading-relaxed" data-id="element-156">
            Ese puente existe. Está dentro de ti. Y este libro te muestra cómo
            cruzarlo.
          </p>
        </motion.div>

        {/* Bottom accent */}
        <motion.div initial={{
        scaleX: 0
      }} whileInView={{
        scaleX: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        delay: 0.4,
        ease: [0.22, 1, 0.36, 1]
      }} className="w-16 h-px bg-gradient-to-r from-transparent via-purple-electric/50 to-transparent mx-auto mt-12" data-id="element-157" />
      </div>
    </section>;
}